module.exports = __webpack_public_path__ + "img/right_arrow.92a30d4a.svg";